export function parse (inistr) {
  const iniObj = {}
  // Read inistring by lines
  const lines = inistr.split('\n')
  let lastSection = null
  let lastConf = null
  lines.forEach(l => {
    l = l.trim()
    // get type
    if (l.match(/^\[.+\]$/)) {
      // section
      lastSection = l.match(/^\[(.+)\]$/)[1]
      iniObj[lastSection] = {}
    } else if (l.match(/^[\w-]+ = .+$/)) {
      // config
      const m = l.match(/^([\w-]+) = (.+)$/)
      lastConf = m[1]
      iniObj[lastSection][m[1]] = m[2]
    } else if (l.match(/^\w.+$/)) {
      // multiconfig
      if (!Array.isArray(iniObj[lastSection][lastConf])) {
        iniObj[lastSection][lastConf] = [iniObj[lastSection][lastConf]]
      }
      const m = l.match(/^(\w.+)$/)
      iniObj[lastSection][lastConf].push(m[1])
    } else {
      // empty
    }
  })
  return iniObj
}
